import { ISplitPaymentRequest, IPaymentShare } from '../interfaces/ISplitPayment';
import IPublicPaymentShare from '../interfaces/IPublicPaymentShare';
import ISplitAllocateInfo from '../interfaces/ISplitAllocateInfo';
import ISplitJoinInfo from '../interfaces/ISplitJoinInfo';
import IPaypalShareConfirmRequest from '../interfaces/IPaypalShareConfirmRequest';
import errorHelpers from '../helpers/errors';

class SplitPayments {
    static GetPublicShare = (shareToken: string): Promise<IPublicPaymentShare> => {
        return fetch(`splitpayments/share/${shareToken}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPublicPaymentShare>);
    };

    static CreateSplit = (siteId: number, invoiceId: number, request: ISplitPaymentRequest): Promise<IPaymentShare[]> => {
        return fetch(`splitpayments/${siteId}/${invoiceId}/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPaymentShare[]>);
    };

    static GetShares = (siteId: number, invoiceId: number): Promise<IPaymentShare[]> => {
        return fetch(`splitpayments/${siteId}/${invoiceId}/shares`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPaymentShare[]>);
    };

    static GetAllocateInfo = (shareToken: string): Promise<ISplitAllocateInfo> => {
        return fetch(`splitpayments/allocate/${shareToken}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<ISplitAllocateInfo>);
    };

    static GetJoinInfo = (shareToken: string): Promise<ISplitJoinInfo> => {
        return fetch(`splitpayments/join/${shareToken}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<ISplitJoinInfo>);
    };

    static JoinSplit = (
        shareToken: string,
        request: { name: string; email: string; slotCount: number; culture?: string }
    ): Promise<IPublicPaymentShare> => {
        return fetch(`splitpayments/join/${shareToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPublicPaymentShare>);
    };

    static AddShares = (shareToken: string, request: ISplitPaymentRequest): Promise<IPaymentShare[]> => {
        return fetch(`splitpayments/addshares/${shareToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPaymentShare[]>);
    };

    static UpdateShareAllocation = (shareToken: string, slotCount: number): Promise<IPublicPaymentShare> => {
        return fetch(`splitpayments/share/${shareToken}/allocation`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ slotCount }),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPublicPaymentShare>);
    };

    static DeclineShare = (shareToken: string): Promise<void> => {
        return fetch(`splitpayments/share/${shareToken}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then(() => undefined);
    };

    static ApplyShareVoucher = (shareToken: string, code: string): Promise<IPublicPaymentShare> => {
        return fetch(`splitpayments/share/${shareToken}/voucher`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code }),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPublicPaymentShare>);
    };

    static RemoveShareVoucher = (shareToken: string, code: string): Promise<IPublicPaymentShare> => {
        return fetch(`splitpayments/share/${shareToken}/voucher`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code }),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPublicPaymentShare>);
    };

    static ConfirmShareNoPayment = (shareToken: string): Promise<IPublicPaymentShare> => {
        return fetch(`splitpayments/share/${shareToken}/confirm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPublicPaymentShare>);
    };

    static ConfirmSharePaypal = (
        shareToken: string,
        request: IPaypalShareConfirmRequest
    ): Promise<IPublicPaymentShare> => {
        return fetch(`splitpayments/share/${shareToken}/paypal/confirm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.json() as Promise<IPublicPaymentShare>);
    };
}

export default SplitPayments;
